import { createContext, useContext, ReactNode } from 'react';
import { User } from 'firebase/auth';

interface AuthContextType {
  user: User | null;
  isAdmin: boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
  user: User | null;
  children: ReactNode;
}

export default function AuthProvider({ user, children }: AuthProviderProps) {
  // Check if user is admin (you can implement your own logic here)
  const isAdmin = user?.email === 'admin@blackbook.com' || 
                  user?.email === 'sam@truckwithchuck.com' || 
                  false;

  return (
    <AuthContext.Provider value={{ user, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}